module.exports = __webpack_public_path__ + "img/39_17.0916c0d7.png";